import React from 'react'
import styled from 'styled-components'

import ConsoleWrapper from '@/docs-partials/endpoints/console'

const List = styled.ul`
  && {
    font-size: 14px;
  }
`

const CaptionsObjectFormat: React.FC = () => {
  return (
    <ConsoleWrapper>
      <List>
        <li>"captions": &#123;</li>
        <li>&nbsp;"&lt;string: ISO 639-1 language code&gt;": &#123;</li>
        <li>&nbsp;&nbsp;"srt": "&lt;string: url to caption file&gt;",</li>
        <li>&nbsp;&nbsp;"vtt": "&lt;string: url to caption file&gt;"</li>
        <li>&nbsp;&#125;</li>
        <li>&#125;</li>
      </List>
    </ConsoleWrapper>
  )
}

export const VideoObjectSchema: React.FC = () => {
  return (
    <div>
      <h2>The Video Object</h2>
      <table>
        <thead>
          <tr>
            <th align="left">Property</th>
            <th align="left">Type</th>
            <th align="left">Description</th>
            <th align="left" />
          </tr>
        </thead>
        <tbody>
          <tr>
            <td align="left">
              <strong>description</strong>
            </td>
            <td align="left">
              <code>string</code>
            </td>
            <td align="left" colSpan={2}>
              Additional information about a Clip
            </td>
          </tr>
          <tr>
            <td align="left">
              <strong>assets</strong>
            </td>
            <td align="left">
              <code>Object</code>
            </td>
            <td align="left" colSpan={2}>
              <p>
                Similar to the images properties, this provides various video renditions with their
                rendition name as the property:
              </p>
              <ul>
                <li>360p</li>
                <li>480p</li>
                <li>720p</li>
                <li>1080p</li>
                <li>4k</li>
              </ul>
              <p>
                The 360p rendition is always present by default. All other renditions will only be
                present if they are available.
              </p>
              <p>Each rendition contains: width, height, url</p>
            </td>
          </tr>
          <tr>
            <td align="left">
              <strong>captions</strong>
            </td>
            <td align="left">
              <code>Object</code>
            </td>
            <td align="left" colSpan={2}>
              <p>
                This object provides URLs to caption files in Subrip and Webvtt format (if
                available) based on transcriptions from the clip audio in the native language.
              </p>
              <p>Format of a captions object:</p>
              <CaptionsObjectFormat />
              <p>
                Additionally the mp4 assets within the video object contain a captions stream too if
                available in the clip’s native language
              </p>
            </td>
          </tr>
          <tr>
            <td align="left">
              <strong>native</strong>
            </td>
            <td align="left">
              <code>string</code>
            </td>
            <td align="left" colSpan={2}>
              ISO 639-1 language code that is the native language caption for the clip. references
              property in captions object
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}
